'use client';

import FadeIn from '../ui/FadeIn';
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

interface RelatedUseCasesProps {
    currentPath: string;
}

const allUseCases = [
    {
        path: '/export-whatsapp-contacts-to-excel',
        title: 'Export WhatsApp Contacts to Excel',
        desc: 'Download all contacts to .xlsx format'
    },
    {
        path: '/whatsapp-group-number-extractor',
        title: 'WhatsApp Group Number Extractor',
        desc: 'Extract participants from any group'
    },
    {
        path: '/export-whatsapp-contacts-to-vcf-vcard',
        title: 'Export to VCF (vCard)',
        desc: 'Compatible with iPhone & Android'
    },
    {
        path: '/whatsapp-unsaved-number-extractor',
        title: 'Unsaved Number Extractor',
        desc: 'Filter and save unknown numbers'
    },
    {
        path: '/whatsapp-chat-list-contact-extractor',
        title: 'Chat List Contact Extractor',
        desc: 'Export contracts from your active chats'
    }
];

export default function RelatedUseCases({ currentPath }: RelatedUseCasesProps) {
    const related = allUseCases.filter(uc => uc.path !== currentPath);

    return (
        <section className="section-padding bg-[var(--color-md-surface-variant)]/30 border-t border-[var(--color-md-outline-variant)]">
            <div className="container mx-auto px-6">
                <FadeIn>
                    <h2 className="text-2xl md:text-3xl font-black text-[var(--color-md-on-surface)] mb-8 text-center">
                        Explore other Use Cases
                    </h2>
                </FadeIn>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {related.map((useCase, i) => (
                        <FadeIn key={useCase.path} delay={i * 0.1} yOffset={20}>
                            <Link href={useCase.path} className="block group h-full">
                                <div className="bg-[var(--color-md-surface)] border border-[var(--color-md-outline)] rounded-2xl p-6 h-full hover:border-[var(--color-md-primary)] transition-all hover:shadow-lg">
                                    <h3 className="font-bold text-[var(--color-md-on-surface)] mb-2 group-hover:text-[var(--color-md-primary)] transition-colors">
                                        {useCase.title}
                                    </h3>
                                    <p className="text-xs text-[var(--color-md-on-surface-variant)] mb-4">
                                        {useCase.desc}
                                    </p>
                                    <div className="flex items-center text-[var(--color-md-primary)] text-xs font-bold mt-auto">
                                        View Tool <ArrowRight className="w-3 h-3 ml-1 group-hover:translate-x-1 transition-transform" />
                                    </div>
                                </div>
                            </Link>
                        </FadeIn>
                    ))}
                </div>
            </div>
        </section>
    );
}
